import { render, staticRenderFns } from "./DashboardDev.vue?vue&type=template&id=3d0cbce4&scoped=true"
import script from "./DashboardDev.vue?vue&type=script&lang=js"
export * from "./DashboardDev.vue?vue&type=script&lang=js"
import style0 from "./DashboardDev.vue?vue&type=style&index=0&id=3d0cbce4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d0cbce4",
  null
  
)

export default component.exports